import { render, staticRenderFns } from "./DataStepOne.vue?vue&type=template&id=23a63075&scoped=true&"
import script from "./DataStepOne.vue?vue&type=script&lang=js&"
export * from "./DataStepOne.vue?vue&type=script&lang=js&"
import style0 from "./DataStepOne.vue?vue&type=style&index=0&id=23a63075&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a63075",
  null
  
)

export default component.exports